import { render } from "./ModalDetails.vue?vue&type=template&id=a8c55df0&scoped=true"
import script from "./ModalDetails.vue?vue&type=script&lang=js"
export * from "./ModalDetails.vue?vue&type=script&lang=js"

import "./ModalDetails.vue?vue&type=style&index=0&id=a8c55df0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8c55df0"]])

export default __exports__